import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Outlet, useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { Modal, Container } from 'react-bootstrap';
import { isMobileOnly } from 'react-device-detect';
import _ from 'lodash';

import {
	getUserInfo,
	getDokuWikiEULA,
	agreeDokuWikiEULA,
	getVersion,
	getDevicesProblems
} from '../action/ClientActions';

import HeaderNav from './dump/HeaderNav';
import CustomButton from './CustomButton';
import SideMenu from './dump/menu/SideMenu';

import './Layout.sass';
import { getPartnerSettings } from "../action/CompaniesActions";
import { useAuth } from "../../../context/AuthContext";

const Layout = (props) => {
	const navigate = useNavigate();
	const { logout } = useAuth();
	const { user, company, whitelabel, loader, toggleCustomLoader } = props;

	const [interval, setIntervals] = useState(null);
	const [userinfo, setUserinfo] = useState({});
	const [sideMenuOpen, setSideMenuOpen] = useState(JSON.parse(localStorage.getItem('openState')) === null ? false : JSON.parse(localStorage.getItem('openState')));
	const [modalEula, setModalEula] = useState(true);
	const [dokuWikiEula, setDokuWikiEula] = useState('');
	const [agreeEula, setAgreeEula] = useState(false);
	const [env, setEnv] = useState(location.hostname);

	useLayoutEffect(() => {
		const { updateUser } = props
		getUserInfo()
			.then((res) => {
				const { user } = res.data.response
				updateUser(user);
				getLastRelease(user);
			})
			.catch(async (error) => {
				console.log('!getUserInfo componentWillMount error: ', error.response, error);

				await logout();
				location.href = '/';
			});
		// Receives list of the partner whitelabel settings - FWSD-4278
		getPartnerWhitelabelSetting()
	}, []);

	useEffect(() => {
		// console.log('!!!Layout: ', props)
		// FWSD-4276 - set global style variables
		// console.log('SIDEMENU ', getComputedStyle(document.documentElement).getPropertyValue('--sidemenu-background-color'))
		// document.documentElement.style.setProperty('--header-logo-extended', 'url("/images/logo-side-menu.png")')
		// document.documentElement.style.setProperty('--header-logo', 'url("/images/player.png")')
		// // document.documentElement.style.setProperty('--loader-url', 'url("https://i.gifer.com/fetch/w300-preview/b4/b4d657e7ef262b88eb5f7ac021edda87.gif")')
		// document.documentElement.style.setProperty('--loader-url', 'url("/images/loader_form_send.gif")')

		isEulaAgreement();
		if (isMobileOnly) {
			document.body.classList.add('mobile');
		}
	}, []);

	useEffect(() => {
		if (company && user && company.company_id) {
			getCompanyDevicesProblems(user)
		}

		return () => {
			if (interval) {
				clearInterval(interval)
				setIntervals(null)
			}
		}
	}, [company.company_id]);

	// Receives list of the partner whitelabel settings - FWSD-4278
	const getPartnerWhitelabelSetting = () => {
		const { updatePartnerWhitelabel } = props;
		getPartnerSettings()
			.then((res) => {
				// console.log('getPartnerWhitelabelSetting res: ', res)
				const { settings } = res.data.response
				if (!_.isEmpty(settings)) {
					updatePartnerWhitelabel(JSON.parse(settings.settings))
				}
			})
			.catch((error) => {
				console.log('!getPartnerWhitelabelSetting error: ', error.response, error)
			})
	}

	const getLastRelease = () => {
		const { updateProjectVersion } = props;

		getVersion()
			.then((res, err) => {
				const version = res.data.response
				updateProjectVersion(version)
			})
			.catch((error) => {
				console.log('!getProjectVersion error: ', error)
			})
	}

	const getCompanyDevicesProblems = (argUser) => {
		const { updateIsDevicesHaveProblems, company } = props;
		const userRole = argUser.roles[0];

		if (userRole === 'partner' && !company.name) {
			return
		}

		getDevicesProblems({ company_id: company.company_id })
			.then((res) => {
				// const { devices } = res.data.response
				// updateAssetsList(devices)
				const devicesHaveProblems = _.has(res.data.response, 'is_red_bubble') && res.data.response.is_red_bubble
				updateIsDevicesHaveProblems(devicesHaveProblems)
			})
			.catch((err) => {
				console.log('getCompanyDevices error: ', err)
			})

		if (interval) {
			clearInterval(interval)
			setIntervals(null)
		}
		setIntervals(setInterval(() => {
			getDevicesProblems({ company_id: company.company_id })
				.then((res) => {
					// const { devices } = res.data.response
					// updateAssetsList(devices)
					const devicesHaveProblems = _.has(res.data.response, 'is_red_bubble') && res.data.response.is_red_bubble
					updateIsDevicesHaveProblems(devicesHaveProblems)
				})
				.catch((err) => {
					console.log('getCompanyDevices error: ', err)
				})
		}, 1800000)) // 30mins
	}

	const toggleSidenav = () => {
		localStorage.setItem('openState', JSON.stringify(!sideMenuOpen))
		setSideMenuOpen(!sideMenuOpen);
	};

	const isEulaAgreement = () => {
		setInterval(() => {
			getUserInfo()
				.then((res, err) => {
					const result = _.get(res, 'data.response.user.eula_was_viewed', true);
					if (!result) {
						getEULA(result);
					}
				})
				.catch((error) => {
					console.log('!isEulaAgreement error', error);
				});
		}, 60000);
	};

	const getEULA = (result) => {
		getDokuWikiEULA(env)
			.then((res, err) => {
				setDokuWikiEula(res.data);
				setModalEula(result);
			})
			.catch((error) => {
				console.log('getEULA error:', error);
			});
	};

	const onAgreeEula = () => {
		agreeDokuWikiEULA()
			.then((res, err) => {
				setModalEula(true);
				setAgreeEula(false);
			})
			.catch((error) => {
				console.log('agreeDokuWikiEula error', error);
			});
	};

	const disagreeEula = async () => {
		await logout();
		location.href = '/';
	};

	const handleScroll = () => {
		const modalBodyCustom = document.getElementsByClassName('modal-body-custom');
		modalBodyCustom[0].addEventListener('scroll', scrollEvent);
		// console.log('modalContentHeight handleScroll', modalBodyCustom[0]);
	};

	const scrollEvent = (event) => {
		const { offsetHeight, scrollHeight, scrollTop } = event.target;
		const result = scrollHeight - offsetHeight;

		const percent = Math.round((scrollTop / result) * 100);

		if (percent > 85) {
			setAgreeEula(true);
		}
	};

	const exitModal = () => {
		document.removeEventListener('scroll', scrollEvent);
	};

	// FWSD-4276
	const isCustomLoaderExists = _.get(whitelabel, 'loader');

	isCustomLoaderExists && toggleCustomLoader(true);

	const isUserExist = user.roles;
	if (!isUserExist) {
		return (
			<div id="" className="container-fluid" />
		)
	}

	if (!user || !['partner', 'custom_partner', 'partner_view'].includes(user.roles[0])) {
		logout();
		navigate('/login');
		toastr.error('This feature is available just for users with Partner role');
		return (<div></div>);
	}

	return (
		<Container fluid className="base-wrapper-container p-0 m-0">
			<SideMenu
				open={sideMenuOpen}
				toggleSidenav={toggleSidenav}
			/>
			<HeaderNav userinfo={userinfo} />
			<div className={`right-content-big-block ${sideMenuOpen ? '' : 'wider'}`}>

				<Outlet />

				{loader}
			</div>

			<Modal
				show={!modalEula}
				onExit={exitModal}
				onEntered={handleScroll}
				dialogClassName="has-error"
				keyboard={false}
				backdrop="static"
			>
				<Modal.Body bsPrefix="modal-body modal-body-custom release-modal">
					<div dangerouslySetInnerHTML={{ __html: dokuWikiEula }} />
				</Modal.Body>
				<Modal.Footer bsPrefix="modal-footer">
					<CustomButton onClick={disagreeEula} variant="delete">Disagree</CustomButton>
					<CustomButton
						disabled={!agreeEula}
						onClick={onAgreeEula}
						variant="primary"
						size="sm"
						title="You must read to the bottom of the EULA before agreeing"
					>
						Agree
					</CustomButton>
				</Modal.Footer>
			</Modal>
		</Container>
	);
}

Layout.propTypes = {
	user: PropTypes.objectOf(PropTypes.any).isRequired,
	company: PropTypes.objectOf(PropTypes.any).isRequired,
	whitelabel: PropTypes.objectOf(PropTypes.any).isRequired,
	updateUser: PropTypes.func.isRequired,
	updateProjectVersion: PropTypes.func.isRequired,
	updateIsDevicesHaveProblems: PropTypes.func.isRequired,
	updatePartnerWhitelabel: PropTypes.func.isRequired
}

const mapStateToProps = ({ user, company, loader }) => ({
	user: user.user,
	whitelabel: user.whitelabel,
	company: company.company,
	loader: loader.loader
})

const mapDispatchToProps = dispatch => ({
	updateUser: (user) => {
		dispatch({ type: 'GET_USER_SUCCESS', payload: user });
	},
	updateProjectVersion: (version) => {
		dispatch({ type: 'SET_PROJECT_VERSION', payload: version });
	},
	updateIsDevicesHaveProblems: (state) => {
		dispatch({ type: 'SET_IS_DEVICES_HAVE_PROBLEMS', payload: state });
	},
	updatePartnerWhitelabel: (state) => {
		dispatch({ type: 'SET_WHITELABEL_SETTINGS', payload: state });
	},
	toggleCustomLoader: (show) => {
		dispatch({ type: 'TOGGLE_CUSTOMLOADER', payload: show });
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
